// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminPermissionsRouteImport } from './routes/admin/permissions'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTenantIdIndexRouteImport } from './routes/_app/$tenantId/index'
import { Route as AppTenantIdSettingsRouteImport } from './routes/_app/$tenantId/settings'
import { Route as AppTenantIdNumbersRouteImport } from './routes/_app/$tenantId/numbers'
import { Route as AppTenantIdCallLogsRouteImport } from './routes/_app/$tenantId/call-logs'

const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/app/onboarding',path: '/app/onboarding',getParentRoute: () => rootRouteImport
          })
const errors503Route = errors503RouteImport.update({
            id: '/(errors)/503',path: '/503',getParentRoute: () => rootRouteImport
          })
const errors500Route = errors500RouteImport.update({
            id: '/(errors)/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const errors404Route = errors404RouteImport.update({
            id: '/(errors)/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const errors403Route = errors403RouteImport.update({
            id: '/(errors)/403',path: '/403',getParentRoute: () => rootRouteImport
          })
const errors401Route = errors401RouteImport.update({
            id: '/(errors)/401',path: '/401',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminPermissionsRoute = AdminPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => AdminRouteRoute
          })
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AdminRouteRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdIndexRoute = AppTenantIdIndexRouteImport.update({
            id: '/$tenantId/',path: '/$tenantId/',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdSettingsRoute = AppTenantIdSettingsRouteImport.update({
            id: '/$tenantId/settings',path: '/$tenantId/settings',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdNumbersRoute = AppTenantIdNumbersRouteImport.update({
            id: '/$tenantId/numbers',path: '/$tenantId/numbers',getParentRoute: () => AppRouteRoute
          })
const AppTenantIdCallLogsRoute = AppTenantIdCallLogsRouteImport.update({
            id: '/$tenantId/call-logs',path: '/$tenantId/call-logs',getParentRoute: () => AppRouteRoute
          })





const AppRouteRouteChildren = {
  AppIndexRoute: AppIndexRoute,AppTenantIdCallLogsRoute: AppTenantIdCallLogsRoute,AppTenantIdNumbersRoute: AppTenantIdNumbersRoute,AppTenantIdSettingsRoute: AppTenantIdSettingsRoute,AppTenantIdIndexRoute: AppTenantIdIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminOrganizationsRoute: AdminOrganizationsRoute,AdminPermissionsRoute: AdminPermissionsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,DashboardRoute: DashboardRoute,errors401Route: errors401Route,errors403Route: errors403Route,errors404Route: errors404Route,errors500Route: errors500Route,errors503Route: errors503Route,AppOnboardingRoute: AppOnboardingRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)